// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"MZ-z","sponsoredTooltipWrapper":"NZ-z","sponsoredTooltip":"OZ-z","newCard":"PZ-z"};